<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>Otel Tanıtımı</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn
                :disabled="!sayfayetki.Save"
                @click="update()"
                slot="activator"
                flat
              >
                <span class="hidden-sm-and-down">
                  {{ $t("Update") }}
                </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Save">{{
                $t("Limited-Authorization")
              }}</span>
              <span v-if="sayfayetki.Save">{{ $t("Update") }}</span>
            </v-tooltip>
          </v-toolbar>
        </v-flex>

        <v-flex xs12 sm12 md12>
          <v-tabs
            style="width: 100%"
            dark=""
            v-model="active"
            color="blue darken-3"
            slot="extension"
            @change="changeTab(active)"
            slider-
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#0">
              {{ $t("tab_general") }}
            </v-tab>
            <v-tab href="#1"> Oda </v-tab>
            <v-tab href="#2"> Konsept </v-tab>
            <!-- <v-tab href="#3"> Konsept Özellikler </v-tab> -->
            <v-tab href="#4"> Çocuk Yaş </v-tab>

            <v-tab-item :id="'0'" style="width: 100%; height: 500px">
              <v-form ref="formOtel" v-model="validOtel" lazy-validation>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md4>
                    <v-card>
                      <v-layout row wrap pa-2>
                        <v-flex xs12 sm12 md12>
                          <v-text-field
                            label="RUNNER ID"
                            :disabled="true"
                            v-model="
                              descriptive.HotelDescriptiveContents
                                .HotelDescriptiveContent.ID
                            "
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-text-field
                            label="Otel Adı"
                            v-model="
                              descriptive.HotelDescriptiveContents
                                .HotelDescriptiveContent.HotelName
                            "
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-select
                            :items="currency"
                            label="Otel Kur"
                            item-text="text"
                            item-value="value"
                            v-model="
                              descriptive.HotelDescriptiveContents
                                .HotelDescriptiveContent.CurrencyCode
                            "
                          >
                          </v-select>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-select
                            :items="otelLanguages"
                            label="Otel Dil"
                            item-text="text"
                            item-value="value"
                            v-model="
                              descriptive.HotelDescriptiveContents
                                .HotelDescriptiveContent.LanguageCode
                            "
                          >
                          </v-select>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-text-field
                            label="Otelci Mesajı"
                            v-model="
                              descriptive.HotelDescriptiveContents
                                .HotelDescriptiveContent.FacilityInfo
                                .TPA_Extensions.HotelierMessage.Text
                            "
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-autocomplete
                            v-model="mailData"
                            id="mailValue"
                            :items="
                              descriptive.HotelDescriptiveContents
                                .HotelDescriptiveContent.ContactInfo.Emails
                                .Email
                            "
                            label="Email"
                            @keypress.enter="addEmail()"
                          >
                            <template v-slot:append-outer>
                              <v-icon color="info" @click="addEmail()"
                                >add_box</v-icon
                              >
                            </template>
                          </v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-autocomplete
                            v-model="phoneData"
                            id="phoneValue"
                            :items="
                              descriptive.HotelDescriptiveContents
                                .HotelDescriptiveContent.ContactInfo.Phones
                                .Phone
                            "
                            label="Telefon"
                            @keypress.enter="addPhone()"
                          >
                            <template v-slot:append-outer>
                              <v-icon color="info" @click="addPhone()"
                                >add_box</v-icon
                              >
                            </template>
                          </v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-card>
                      <v-layout row wrap pa-2>
                        <v-flex xs12 sm12 md12>
                          <v-select
                            :items="countries"
                            label="Ülke"
                            item-text="turkishName"
                            item-value="binaryCode"
                            @change="
                              getCities(
                                descriptive.HotelDescriptiveContents
                                  .HotelDescriptiveContent.ContactInfo.Addresses
                                  .Address[0].CountryName
                              )
                            "
                            v-model="
                              descriptive.HotelDescriptiveContents
                                .HotelDescriptiveContent.ContactInfo.Addresses
                                .Address[0].CountryName
                            "
                          >
                          </v-select>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-select
                            :items="cities"
                            label="Şehir"
                            item-text="city"
                            item-value="city"
                            v-model="
                              descriptive.HotelDescriptiveContents
                                .HotelDescriptiveContent.ContactInfo.Addresses
                                .Address[0].CityName
                            "
                          >
                          </v-select>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-text-field
                            label="İlçe"
                            v-model="
                              descriptive.HotelDescriptiveContents
                                .HotelDescriptiveContent.ContactInfo.Addresses
                                .Address[0].ProvinceName
                            "
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-text-field
                            label="Adres"
                            v-model="
                              descriptive.HotelDescriptiveContents
                                .HotelDescriptiveContent.ContactInfo.Addresses
                                .Address[0].AddressLine
                            "
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-text-field
                            label="Adres 2"
                            v-model="
                              descriptive.HotelDescriptiveContents
                                .HotelDescriptiveContent.ContactInfo.Addresses
                                .Address[0].AboutLocation
                            "
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <template>
                            <v-select
                              v-model="selectedServices"
                              :items="services"
                              label="Otel Servisleri"
                              item-text="FilterName"
                              item-value="FilterId"
                              multiple
                            >
                              <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index === 0">
                                  <span>{{ item.FilterName }}</span>
                                </v-chip>
                                <span
                                  v-if="index === 1"
                                  class="grey--text caption"
                                  >(+{{
                                    selectedServices.length - 1
                                  }}
                                  diğer)</span
                                >
                              </template>
                            </v-select>
                          </template>
                        </v-flex>
                        <v-flex xs12 sm6 md12>
                          <v-item-group>
                            <v-container>
                              <v-layout wrap>
                                <v-flex xs4 md3>
                                  <v-item>
                                    <v-card
                                      slot-scope="{ active, toggle }"
                                      :color="active ? 'primary' : ''"
                                      class="d-flex align-center"
                                      dark
                                      height="75"
                                      width="75"
                                      @click="toggle"
                                    >
                                      <v-scroll-y-transition>
                                        <v-btn
                                          v-if="photoStatus"
                                          flat
                                          fab
                                          @click="addFiles(1)"
                                        >
                                          <v-icon color="info"
                                            >add_a_photo</v-icon
                                          >
                                        </v-btn>
                                        <v-btn
                                          v-else
                                          flat
                                          fab
                                          @click="addFiles(1)"
                                        >
                                          <v-icon color="info">check</v-icon>
                                        </v-btn>
                                      </v-scroll-y-transition>
                                    </v-card>
                                  </v-item>
                                </v-flex>
                                <v-flex pl-1 xs4 md3>
                                  <v-item>
                                    <v-card
                                      slot-scope="{ active, toggle }"
                                      :color="active ? 'primary' : ''"
                                      class="d-flex align-center"
                                      dark
                                      height="75"
                                      width="75"
                                      @click="toggle"
                                    >
                                      <v-scroll-y-transition>
                                        <v-btn
                                          v-if="photoStatustwo"
                                          flat
                                          fab
                                          @click="addFiles(2)"
                                        >
                                          <v-icon color="info"
                                            >add_a_photo</v-icon
                                          >
                                        </v-btn>
                                        <v-btn
                                          v-else
                                          flat
                                          fab
                                          @click="addFiles(2)"
                                        >
                                          <v-icon color="info">check</v-icon>
                                        </v-btn>
                                      </v-scroll-y-transition>
                                    </v-card>
                                  </v-item>
                                </v-flex>
                                <v-flex pl-1 xs4 md3>
                                  <v-item>
                                    <v-card
                                      slot-scope="{ active, toggle }"
                                      :color="active ? 'primary' : ''"
                                      class="d-flex align-center"
                                      dark
                                      height="75"
                                      width="75"
                                      @click="toggle"
                                    >
                                      <v-scroll-y-transition>
                                        <v-btn
                                          flat
                                          v-if="photoStatusthree"
                                          fab
                                          @click="addFiles(3)"
                                        >
                                          <v-icon color="info"
                                            >add_a_photo</v-icon
                                          >
                                        </v-btn>
                                        <v-btn
                                          flat
                                          v-else
                                          fab
                                          @click="addFiles(3)"
                                        >
                                          <v-icon color="info">check</v-icon>
                                        </v-btn>
                                      </v-scroll-y-transition>
                                    </v-card>
                                  </v-item>
                                </v-flex>
                                <v-flex pl-1 xs4 md3>
                                  <v-item>
                                    <v-card
                                      slot-scope="{ active, toggle }"
                                      :color="active ? 'primary' : ''"
                                      class="d-flex align-center"
                                      dark
                                      height="75"
                                      width="75"
                                      @click="toggle"
                                    >
                                      <v-scroll-y-transition>
                                        <v-btn
                                          flat
                                          v-if="photoStatusfour"
                                          fab
                                          @click="addFiles(4)"
                                        >
                                          <v-icon color="info"
                                            >add_a_photo</v-icon
                                          >
                                        </v-btn>
                                        <v-btn
                                          flat
                                          v-else
                                          fab
                                          @click="addFiles(4)"
                                        >
                                          <v-icon color="info">check</v-icon>
                                        </v-btn>
                                      </v-scroll-y-transition>
                                    </v-card>
                                  </v-item>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-item-group>

                          <v-form
                            ref="formaktarim"
                            id="formaktarim"
                            method="post"
                            enctype="multipart/form-data"
                            v-model="valid"
                            lazy-validation
                          >
                            <input
                              hidden
                              :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                              type="file"
                              id="file"
                              ref="file"
                              multiple
                              v-on:change="handleFileUpload(1)"
                            />
                          </v-form>

                          <v-form
                            ref="formaktarimtwo"
                            id="formaktarimtwo"
                            method="post"
                            enctype="multipart/form-data"
                            v-model="valid"
                            lazy-validation
                          >
                            <input
                              hidden
                              :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                              type="file"
                              id="filetwo"
                              ref="filetwo"
                              multiple
                              v-on:change="handleFileUpload(2)"
                            />
                          </v-form>

                          <v-form
                            ref="formaktarimthree"
                            id="formaktarimthree"
                            method="post"
                            enctype="multipart/form-data"
                            v-model="valid"
                            lazy-validation
                          >
                            <input
                              hidden
                              :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                              type="file"
                              id="filethree"
                              ref="filethree"
                              multiple
                              v-on:change="handleFileUpload(3)"
                            />
                          </v-form>

                          <v-form
                            ref="formaktarimfour"
                            id="formaktarimfour"
                            method="post"
                            enctype="multipart/form-data"
                            v-model="valid"
                            lazy-validation
                          >
                            <input
                              hidden
                              :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                              type="file"
                              id="filefour"
                              ref="filefour"
                              multiple
                              v-on:change="handleFileUpload(4)"
                            />
                          </v-form>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-btn outline color="primary" @click.native="(changePhotos = !changePhotos)" dark>Fotoğrafları Düzenle</v-btn>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12 v-show="changePhotos">
                          <v-layout row wrap>
                            <v-flex
                              xs12
                              sm6
                              md12
                              v-for="(item, index) in otelImageList"
                              :key="index"
                            >
                              <v-layout row wrap>
                                <v-flex xs8 sm6 md10>
                                  <img
                                    style="max-width: 100px; max-height: 100px"
                                    :src="item.imageUrl"
                                  />
                                </v-flex>
                                <v-flex xs4 sm6 md2>
                                  <v-btn
                                    @click="deleteOtelImage(item)"
                                    flat
                                    icon
                                    color="red"
                                  >
                                    <v-icon large>delete</v-icon>
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-card>
                      <v-layout row wrap pa-2>
                        <v-flex xs12 sm12 md12>
                          <v-text-field
                            label="Enlem"
                            v-model="
                              descriptive.HotelDescriptiveContents
                                .HotelDescriptiveContent.HotelInfo.Position
                                .Latitude
                            "
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-text-field
                            label="Boylam"
                            v-model="
                              descriptive.HotelDescriptiveContents
                                .HotelDescriptiveContent.HotelInfo.Position
                                .Longitude
                            "
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-text-field
                            label="Giriş Saati"
                            v-model="
                              descriptive.HotelDescriptiveContents
                                .HotelDescriptiveContent.Policies.Policy
                                .PolicyInfo.CheckInTime
                            "
                            value="12:30:00"
                            type="time"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-text-field
                            label="Çıkış Saati"
                            v-model="
                              descriptive.HotelDescriptiveContents
                                .HotelDescriptiveContent.Policies.Policy
                                .PolicyInfo.CheckOutTime
                            "
                            value="12:30:00"
                            type="time"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-checkbox
                            label="Çocuk Kalabilir"
                            v-model="
                              descriptive.HotelDescriptiveContents
                                .HotelDescriptiveContent.Policies.Policy
                                .PolicyInfo.KidsStayFree
                            "
                          ></v-checkbox>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <template>
                            <v-select
                              v-model="selectedFacilities"
                              :items="facilities"
                              label="Otel Özellikleri"
                              item-text="FilterName"
                              item-value="FilterId"
                              multiple
                            >
                              <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index === 0">
                                  <span>{{ item.FilterName }}</span>
                                </v-chip>
                                <span
                                  v-if="index === 1"
                                  class="grey--text caption"
                                  >(+{{
                                    selectedFacilities.length - 1
                                  }}
                                  diğer)</span
                                >
                              </template>
                            </v-select>
                          </template>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-tab-item>

            <v-tab-item :id="'1'" style="width: 100%; height: 500px">
              <roomtab :isChoosen="isRoomTabChoosen"></roomtab>
            </v-tab-item>

            <v-tab-item :id="'2'" style="width: 100%; height: 500px">
              <ratetab :isChoosen="isRateTabChoosen"></ratetab>
            </v-tab-item>

            <!-- <v-tab-item :id="'3'" style="width: 100%; height: 500px">
              <ratepropertytab
                :isChoosen="isRatePropertyTabChoosen"
              ></ratepropertytab>
            </v-tab-item> -->

            <v-tab-item :id="'4'" style="width: 100%; height: 500px">
              <childAgeTab :isChoosen="isChildAgeTab"></childAgeTab>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>
  
  <script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import auth from "@/api/auth.js";
import roomtab from "@/components/app/hotelrunner/oteltanitim/roomtab.vue";
import ratetab from "@/components/app/hotelrunner/oteltanitim/ratetab.vue";
import ratepropertytab from "@/components/app/hotelrunner/oteltanitim/ratepropertytab.vue";
import helpers from "@/components/app/customcomp/helpers.js";
import childAgeTab from "@/components/app/hotelrunner/oteltanitim/childAgeTab.vue";
import axios from "axios";

export default {
  data() {
    return {
      changePhotos:false,
      isChildAgeTab: false,
      isRatePropertyTabChoosen: false,
      isRateTabChoosen: false,
      isRoomTabChoosen: false,
      secilenSayi: 0,
      file: [],
      otelImageList: [],
      photoStatus: true,
      photoStatustwo: true,
      photoStatusthree: true,
      photoStatusfour: true,
      valid: true,
      phoneData: null,
      mailData: null,
      otelLanguages: [
        {
          text: "Türkçe",
          value: "TR",
        },
        {
          text: "İngilizce",
          value: "EN",
        },
        {
          text: "Almanca",
          value: "DE",
        },
      ],
      currency: [
        {
          text: "USD",
          value: "USD",
        },
        {
          text: "EUR",
          value: "EUR",
        },
        {
          text: "TL",
          value: "TL",
        },
      ],
      descriptive: {
        HotelDescriptiveContents: {
          NextRequest: true,
          HotelDescriptiveContent: {
            ID: 0,
            HotelCode: null,
            HotelName: null,
            LanguageCode: null,
            HotelDescriptiveContentNotifType: null,
            CurrencyCode: null,
            MultimediaDescriptions: {
              MultimediaDescription: {
                ImageItems: {
                  ImageItem: [
                    {
                      URL: null,
                    },
                  ],
                },
              },
            },
            Policies: {
              Policy: {
                PolicyInfo: {
                  CheckInTime: "00:00:00",
                  CheckOutTime: "00:00:00",
                  KidsStayFree: null,
                },
              },
            },
            FacilityInfo: {
              Facilities: {
                Facility: [],
              },
              TPA_Extensions: {
                HotelierMessage: {
                  Language: null,
                  Text: null,
                },
              },
            },
            HotelInfo: {
              Position: {
                Longitude: null,
                Latitude: null,
              },
              Services: {
                Service: [],
              },
            },
            ContactInfo: {
              Addresses: {
                Address: [
                  {
                    CountryName: null,
                    ProvinceName: null,
                    ProvinceCode: null,
                    CityName: null,
                    PostalCode: null,
                    AddressLine: null,
                    AboutLocation: null,
                  },
                ],
              },
              Emails: {
                Email: [],
              },
              Phones: {
                Phone: [],
              },
            },
          },
        },
      },
      active: "0",
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      validOtel: true,
      cities: [],
      countries: [],
      selectedServices: [],
      services: [],
      selectedFacilities: [],
      facilities: [],
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: true, //canliya cikarken duzelt do it false
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
    };
  },
  methods: {
    deleteOtelImage(val) {
      this.loadingvmodel = true;
      var params = {
        Ref: val.ref,
        Url: val.imageUrl,
      };

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/DeleteOtelImage", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            if (response.data.status == true) {
              this.otelImageList = response.body.imageItems;
              this.loadingvmodel = false;
              this.text1 = response.data.message;
              this.snackbar = true;
            } else {
              this.loadingvmodel = false;
              this.text1 = response.data.message;
              this.snackbar = true;
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    UploadImages(val) {
      if (this.file.length > 0) {
        this.loadingvmodel = true;
        let formData = new FormData();
        formData.append("OtelId", val.OtelId);
        for (var i = 0; i < this.file.length; i++) {
          let file = this.file[i];
          formData.append("file[" + i + "]", file);
        }

        axios.defaults.baseURL = auth.HOTELRUNNER_API_URL;
        axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
        axios
          .post(auth.HOTELRUNNER_API_URL + "api/v1/UploadPhoto", formData, {
            headers: {
              Authorization:
                "Basic " +
                window.btoa(
                  auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
                ),
            },
          })
          .then((response) => {
            if (response.data.status == true) {
              this.loadingvmodel = false;
              this.text1 = response.data.message;
              this.snackbar = true;
              window.location.reload();
            } else {
              this.loadingvmodel = false;
              this.text1 = response.data.message;
              this.snackbar = true;
            }
          })
          .catch(function () {
            this.loadingvmodel = false;
            this.text1 = this.$t("Error-in-file-transfer-try-again");
            this.snackbar = true;
          });
      } else {
        window.location.reload();
      }
    },
    handleFileUpload(val) {
      //this.file = []
      if (this.secilenSayi >= 4) {
        this.text1 = "Maksimum 4 Adet fotoğraf yükleyebilirsiniz.";
        this.snackbar = true;
      } else {
        this.cancelPhoto = true;

        var uploadedFiles;
        switch (val) {
          case 1:
            if (this.$refs.file.files.length > 1) {
              this.text1 =this.$t('Please-Select-One-Photo-at-a-Time.');
              this.snackbar = true;
            } else {
              uploadedFiles = this.$refs.file.files;
            }
            break;
          case 2:
            if (this.$refs.filetwo.files.length > 1) {
              this.text1 =this.$t('Please-Select-One-Photo-at-a-Time.');
              this.snackbar = true;
            } else {
              uploadedFiles = this.$refs.filetwo.files;
            }
            break;
          case 3:
            if (this.$refs.filethree.files.length > 1) {
              this.text1 =this.$t('Please-Select-One-Photo-at-a-Time.');
              this.snackbar = true;
            } else {
              uploadedFiles = this.$refs.filethree.files;
            }
            break;
          case 4:
            if (this.$refs.filefour.files.length > 1) {
              this.text1 =this.$t('Please-Select-One-Photo-at-a-Time.');
              this.snackbar = true;
            } else {
              uploadedFiles = this.$refs.filefour.files;
            }
            break;

          default:
            break;
        }
        var lg = uploadedFiles.length; // get length

        var items = uploadedFiles;

        if (lg > 0) {
          for (var i = 0; i < lg; i++) {
            var fileType = items[i].type; // get file type

            if (fileType === "image/png" || fileType === "image/jpeg") {
              this.secilenSayi += 1;
            } else {
              this.text1 =
                "Dosya Uzantısını kontrol ediniz. Sadece png ve jpg eklenebilir.";
              this.snackbar = true;
              this.secilenSayi = this.secilenSayi - 1;
            }
          }
        }

        if (this.secilenSayi >= 1) {
          // this.dosya1mesaj =
          //   this.secilenSayi + " " + this.$t("pcs-of-files-selected");
          switch (val) {
            case 1:
              this.photoStatus = false;
              break;
            case 2:
              this.photoStatustwo = false;
              break;
            case 3:
              this.photoStatusthree = false;
              break;
            case 4:
              this.photoStatusfour = false;
              break;

            default:
              break;
          }
        } else {
          this.dosya1mesaj = this.$t("file-has-been-chosen");
        }

        if (uploadedFiles.length > 0) {
          for (var i = 0; i < uploadedFiles.length; i++) {
            this.file.push(uploadedFiles[i]);
          }
        }
      }
    },
    addFiles(val) {
      switch (val) {
        case 1:
          this.$refs.file.click();
          break;
        case 2:
          this.$refs.filetwo.click();
          break;
        case 3:
          this.$refs.filethree.click();
          break;
        case 4:
          this.$refs.filefour.click();
          break;
        default:
          break;
      }
    },
    prepareList(val, type) {
      // 1 : faciliest 2:services
      var list = [];
      val.forEach((element) => {
        var item = {
          Code: element.FilterId.toString(),
        };
        list.push(item);
      });

      switch (type) {
        case 1:
          this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.FacilityInfo.Facilities.Facility =
            list;
          break;
        case 2:
          this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.HotelInfo.Services.Service =
            list;
          break;
        default:
          break;
      }
    },
    update() {
      if (this.$refs.formOtel.validate()) {
        this.loadingvmodel = true;
        this.prepareList(this.selectedFacilities, 1);
        this.prepareList(this.selectedFacilities, 2);

        var params = this.descriptive;
        this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.HotelCode =
          this.$route.query.kod.toString();
        this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.Policies.Policy.PolicyInfo.KidsStayFree =
          this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent
            .Policies.Policy.PolicyInfo.KidsStayFree == true
            ? "1"
            : "0";
        this.$http
          .post(
            auth.HOTELRUNNER_API_URL +
              "api/hotels/ota/OTA_HotelDescriptiveContentNotif",
            params,
            {
              headers: {
                Authorization:
                  "Basic " +
                  window.btoa(
                    auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
                  ),
              },
            }
          )
          .then(
            (response) => {
              if (response.body.Status) {
                this.UploadImages(response.body);
                this.text1 = response.body.Message;
                this.snackbar = true;
                this.loadingvmodel = false;
              } else {
                this.loadingvmodel = false;
                this.text1 = response.body.Message;
                this.snackbar = true;
              }
            },
            (response) => {
              if (response.status === 0) {
                this.text1 =
                  "Service Unavailable-OTA_HotelDescriptiveContentNotif";
                this.snackbar = true;
                this.loadingvmodel = false;
              } else {
                this.text1 =
                  "Service Unavailable-OTA_HotelDescriptiveContentNotif";
                this.snackbar = true;
                this.loadingvmodel = false;
              }
            }
          );
      }
    },
    addPhone() {
      this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.ContactInfo.Phones.Phone.push(
        document.getElementById("phoneValue").value
      );
    },
    addEmail() {
      this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.ContactInfo.Emails.Email.push(
        document.getElementById("mailValue").value
      );
    },
    changeTab(val) {
      // 0:main 1 : roomtab 2:ratetab 3 :rateproperty
      switch (val) {
        case "0":
          this.isRatePropertyTabChoosen = false;
          this.isRateTabChoosen = false;
          this.isRoomTabChoosen = false;
          this.isChildAgeTab = false;
          break;
        case "1":
          this.isRatePropertyTabChoosen = false;
          this.isRateTabChoosen = false;
          this.isRoomTabChoosen = true;
          this.isChildAgeTab = false;
          break;
        case "2":
          this.isRatePropertyTabChoosen = false;
          this.isRateTabChoosen = true;
          this.isRoomTabChoosen = false;
          this.isChildAgeTab = false;
          break;
        case "3":
          this.isRatePropertyTabChoosen = true;
          this.isRateTabChoosen = false;
          this.isRoomTabChoosen = false;
          this.isChildAgeTab = false;
          break;
        case "4":
          this.isRatePropertyTabChoosen = false;
          this.isRateTabChoosen = false;
          this.isRoomTabChoosen = false;
          this.isChildAgeTab = true;
          break;
        default:
          break;
      }
    },
    getCities(val) {
      if (this.countries != null) {
        let country = this.countries.find(
          (country) => country.binaryCode === val
        );
        var params = {
          CountryId: country.countryId,
        };

        this.$http
          .post(auth.HOTELRUNNER_API_URL + "api/v1/GetCities", params, {
            headers: {
              Authorization:
                "Basic " +
                window.btoa(
                  auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
                ),
            },
          })
          .then(
            (response) => {
              this.cities = response.body;
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-OzellikList";
                this.snackbar = true;
                this.loadingvmodel = false;
              } else {
                this.text1 = "Service Unavailable-OzellikList";
                this.snackbar = true;
                this.loadingvmodel = false;
              }
            }
          );
      } else {
        setTimeout(() => {
          this.getCities(val);
        }, 300);
      }
    },
    getCountries() {
      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/GetCountries", null, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.countries = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    getOtel(val) {
      this.loadingvmodel = true;
      var params = {
        OtelId: parseInt(val),
      };

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/GetOtelForNext", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.ID =
              response.body.otelId;
            this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.HotelName =
              response.body.hotelName;
            this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.LanguageCode =
              response.body.language;
            this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.HotelDescriptiveContentNotifType =
              "Modify";
            this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.Policies.Policy.PolicyInfo.CheckInTime =
              response.body.checkInTime;
            this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.Policies.Policy.PolicyInfo.CheckOutTime =
              response.body.checkOutTime;
            this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.Policies.Policy.PolicyInfo.KidsStayFree =
              response.body.kidsStayFree;
            this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.FacilityInfo.TPA_Extensions.HotelierMessage.Text =
              response.body.hotelierText;
            this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.HotelInfo.Position.Longitude =
              response.body.longitude;
            this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.HotelInfo.Position.Latitude =
              response.body.latitude;
            this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.CurrencyCode =
              response.body.currency;
            this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.ContactInfo.Addresses.Address[0].ProvinceName =
              response.body.address.ilce;
            this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.ContactInfo.Addresses.Address[0].AboutLocation =
              response.body.address.konumAciklama;

            this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.ContactInfo.Addresses.Address[0].CountryName =
              response.body.address.ulke;
            this.getCities(response.body.address.ulke);
            this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.ContactInfo.Addresses.Address[0].CityName =
              response.body.address.sehir;
            this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.ContactInfo.Addresses.Address[0].AddressLine =
              response.body.address.adres;

            this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.ContactInfo.Emails.Email =
              this.prepareEmailList(response.body.emails);
            this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.ContactInfo.Phones.Phone =
              this.preparePhoneList(response.body.phones);
            this.selectedFacilities = this.prepareFacilityList(
              response.body.facilities
            );
            this.selectedServices = this.prepareServiceList(
              response.body.service
            );
            this.descriptive.HotelDescriptiveContents.HotelDescriptiveContent.MultimediaDescriptions.MultimediaDescription.ImageItems.ImageItem =
              this.prepareImageList(response.body.imageItems);
            this.otelImageList = response.body.imageItems;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
            }
          }
        );
    },
    prepareImageList(val) {
      var imageList = [];
      val.forEach((element) => {
        var item = {
          URL: element.imageUrl,
        };
        imageList.push(item);
      });
      return imageList;
    },
    prepareServiceList(val) {
      var serviceList = [];
      val.forEach((element) => {
        var item = {
          FilterId: element.servisKod,
        };
        serviceList.push(item);
      });
      return serviceList;
    },
    prepareFacilityList(val) {
      var facilityList = [];
      val.forEach((element) => {
        var item = {
          FilterId: element.ozellikId,
        };
        facilityList.push(item);
      });
      return facilityList;
    },
    preparePhoneList(val) {
      var phoneList = [];
      val.forEach((element) => {
        phoneList.push(element.tel);
      });
      return phoneList;
    },
    prepareEmailList(val) {
      var emailList = [];
      val.forEach((element) => {
        emailList.push(element.email);
      });
      return emailList;
    },

    getServices() {
      var params = {
        Language: "tr",
        AllItems: true,
      };

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/OtelServices", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.services = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },

    getFacilities() {
      var params = {
        Language: "tr",
        AllItems: true,
      };

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/OtelProperties", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.facilities = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
              this.progress = false;
            } else {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
              this.progress = false;
            }
          }
        );
    },
    getAccountDetails() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params = {
        CustomerID: credentials.MusteriID,
        ServiceID: 2,
      };

      this.$http
        .post(auth.API_URL + "api/Booking/ServiceInfoLoad", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            auth.HOTELRUNNERUSERNAME = response.body.UserName;
            auth.HOTELRUNNERUSERPASS = response.body.Password;
            this.getFacilities();
            this.getServices();
            this.getCountries();
            setTimeout(() => {
              this.getOtel(this.$route.query.kod);
            }, 1000);
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable - ServiceInfoLoad";
              this.loadingvmodel = false;
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable - ServiceInfoLoad";
              this.loadingvmodel = false;
              this.snackbar = true;
            }
          }
        );
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    roomtab,
    ratetab,
    ratepropertytab,
    childAgeTab,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    if (this.sayfayetki.Status == true) {
      //YETKİ OK
      this.loadingvmodel = true;
      this.getAccountDetails();
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
};
</script>
  
  <style>
</style>
  
  